import { Component, Input } from '@angular/core';
import { MessageService } from 'primeng/api';
import { DatePickerModule } from 'primeng/datepicker';
import { StudentService } from 'src/app/private/services/student.service';
import { SharedModule } from 'src/app/private/shared/shared.module';

@Component({
  selector: 'app-student-overview',
  imports: [SharedModule, DatePickerModule],
  templateUrl: './student-overview.component.html',
  styleUrl: './student-overview.component.scss'
})
export class StudentOverviewComponent {

  @Input() studentDetails: any;

  @Input() allCourses: any[] = [];
  @Input() batchList: any[] = [];
  @Input() academicYearList: any[] = [];
  @Input() feeCategoryList: any[] = [];
  @Input() departmentList: any[] = [];

  @Input() hostelCategoryList: any[] = [];
  @Input() scholarshipTypeList: any[] = [];
  @Input() transportRouteList: any[] = [];
  @Input() allLeadFeilds: any[] = [];
  @Input() fieldValues: any = {};

  loading: boolean = false;

  constructor(
    private studentAPi : StudentService,
    private messageService: MessageService
  ) { }


  today: Date = new Date();


  // Dropdown mock data
  genderOptions = [
    { label: 'Male', value: 'Male' },
    { label: 'Female', value: 'Female' },
    { label: 'Other', value: 'Other' },
  ];

    admissionModeOptions = [
        { label: 'Online', value: 'Online' },
    { label: 'Offline', value: 'Offline' },
    { label: 'Hybrid', value: 'Hybrid' }
  ];

    admissionTypeOptions = [
    { label: 'Regular', value: 'Regular' },
    { label: 'Transfer', value: 'Transfer' },
    { label: 'Lateral', value: 'Lateral' },
    { label: 'Readmission', value: 'Readmission' },
    { label: 'Dropout', value: 'Dropout' },
  ];

  ngOnInit(): void { 
    console.log('Student Details:', this.studentDetails);
    console.log('Academic Year List:', this.academicYearList);

    console.log('course list:', this.allCourses);

    // studentDetails dob
    if (this.studentDetails && this.studentDetails.dob) {
      this.studentDetails.dob = new Date(this.studentDetails.dob);
    }
  }


  updateStudent() {
    console.log('Update Student Details:', this.studentDetails);
    this.loading = true;
    this.studentAPi.updateStudent( this.studentDetails).subscribe({
      next: (response) => {
        this.loading = false;
        console.log('Student updated successfully:', response);
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Student details updated successfully.' });
      },
      error: (error) => {
        this.loading = false;
        console.error('Error updating student:', error);
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to update student details.' });
      }
    })
  }

}
